@for(card of promotionCards; track $index) {
<div class="bg-zinc-50 flex flex-col lg:flex-row">
  <img
    [src]="card.imageUrl"
    [alt]="card.title"
    class="flex-1 w-full lg:h-[330px] object-fill"
  />

  <div
    class="flex-1 flex flex-col gap-6 lg:justify-between px-4 py-6 lg:pb-6 lg:pt-10 lg:px-6"
  >
    <div class="flex flex-col gap-1">
      <h1 class="text-lg lg:text-2xl text-zinc-800">{{ card.title }}</h1>
      <p class="text-xs lg:text-base text-zinc-500 font-medium">
        {{ card.subtitle }}
      </p>
    </div>

    <div class="flex flex-col gap-4">
      <ul class="flex flex-col gap-2 text-sm font-medium text-zinc-800">
        @for (point of card.mainPoints; track $index) {
        <li class="flex items-center">
          <span class="mr-2">•</span>
          <span>{{ point }}</span>
        </li>
        }
      </ul>

      <div class="w-full h-px bg-zinc-200"></div>

      @if (card.additionalInfo && card.additionalInfo.length > 0) {
      <div class="text-xs font-medium text-zinc-500 space-y-1">
        @for (info of card.additionalInfo; track $index) {
        <p [innerHTML]="info"></p>
        }
      </div>
      }
    </div>
  </div>
</div>
}
